import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

function OrderFormPrintSendOptions(props) {
  return (
    <React.Fragment>

      <Grid item sm={12}>
        <Typography variant="overline">Label Printing & Sending Options:</Typography>
        <div style={{ borderBottom: '1px dashed black' }}></div>
      </Grid>

      <Grid item sm={7} style={{ paddingTop: 12 }}>
        <FormControl fullWidth>
          <FormLabel>Send Emails To</FormLabel>
          {props.data.emails &&
            <List style={{ paddingBottom: 0, borderBottom: '1px dotted gray' }}>
              {props.data.emails.map((eml, dex) =>
                <ListItem key={'eml-opt-' + dex} disablePadding style={{ borderTop: '1px dotted gray' }}
                  secondaryAction={
                    <Button variant="contained" color="error" size="small" onClick={() => props.onEmailsChange('remove', dex)}>Remove</Button>
                  }
                >
                  <ListItemIcon>
                    <Checkbox edge="start" checked={eml.checked} tabIndex={-1} disableRipple
                      onChange={(evt, chk) => props.onEmailsChange(chk ? 'check' : 'uncheck', dex)} />
                  </ListItemIcon>
                  <ListItemText id={dex} primary={
                    <div>
                      <div style={{ float: 'right', marginRight: 110 }}>
                        <ButtonGroup size="small">
                          <Button variant={'to' === eml.action ? 'contained' : 'outlined'} onClick={() => props.onEmailsChange('action', dex, 'to')}>To</Button>
                          <Button variant={'cc' === eml.action ? 'contained' : 'outlined'} onClick={() => props.onEmailsChange('action', dex, 'cc')}>Cc</Button>
                          <Button variant={'bcc' === eml.action ? 'contained' : 'outlined'} onClick={() => props.onEmailsChange('action', dex, 'bcc')}>Bcc</Button>
                        </ButtonGroup>
                      </div>
                      {eml.email}
                    </div>
                  } />
                </ListItem>
              )}
            </List>
          }
          <div style={{ padding: 6, borderBottom: '1px dotted gray' }}>
            <div style={{ float: 'right', marginRight: 14 }}>
              <Button variant="contained" color="success" size="small" onClick={() => props.onEmailsChange('add')}>Add</Button>
            </div>
            <div style={{ float: 'right', marginRight: 26 }}>
              <ButtonGroup size="small">
                <Button variant={'to' === props.addingEmailAction ? 'contained' : 'outlined'}
                  onClick={() => props.setAddingEmailAction('to')}>To</Button>
                <Button variant={'cc' === props.addingEmailAction ? 'contained' : 'outlined'}
                  onClick={() => props.setAddingEmailAction('cc')}>Cc</Button>
                <Button variant={'bcc' === props.addingEmailAction ? 'contained' : 'outlined'}
                  onClick={() => props.setAddingEmailAction('bcc')}>Bcc</Button>
              </ButtonGroup>
            </div>
            <TextField type="email" size="small" variant="standard" label=""
              placeholder="enter email address..." onFocus={(evt) => evt.target.select()}
              value={props.addingEmailAddress} onChange={(evt) => props.setAddingEmailAddress(evt.target.value)}
              style={{
                marginLeft: 50,
                width: 'calc(100% - 320px)'
              }}
            />
          </div>
        </FormControl>
      </Grid>

      <Grid item sm={5}>
        <FormControl>
          <FormLabel>Label Print Type</FormLabel>
          <RadioGroup value={props.printType} onChange={(evt) => props.setPrintType(evt.target.value)}>
            <FormControlLabel value="full" control={<Radio />} label="Full Label with instructions (Standard Letter 8.5 x 11 in)" />
            <FormControlLabel value="short" control={<Radio />} label="Short Label without instructions (4.0 x 6.0 inches)" />
          </RadioGroup>
          <br />
          <br />
          {props.isReadyToPrint &&
            <div style={{ textAlign: 'right' }}>
              <Button variant="contained" size="small" color="success" onClick={props.downloadLabelPDF} style={{ marginLeft: 12 }}>Download Label PDF</Button>
              <Button variant="contained" size="small" color="success" onClick={props.sendEmails} style={{ marginLeft: 12 }}>Send Emails</Button>
            </div>
          }
        </FormControl>
      </Grid>

    </React.Fragment>
  );
}

export default OrderFormPrintSendOptions;
